"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Backoff = require("backo2");
var _ = require("lodash");
var isThrottlingError = function (response) {
    if (!response.headers) {
        //For syntax errors in JSON response, we don't get response.config object
        return false;
    }
    var errorTypeHeaderVal = response.headers['x-amzn-errortype'];
    return errorTypeHeaderVal && _.startsWith(errorTypeHeaderVal, "ThrottlingException:") && response.status === 400;
};
var isRetriableError = function (response) {
    //response will be undefined when the server did not respond at all
    if (!response || isThrottlingError(response)) {
        return true;
    }
    //-1 status code is returned when a network request is cancelled by the browser due to network glitch
    //Other status codes are common retriable errors.
    return response.status === 502 || response.status === 503 || response.status === 504 || response.status === -1;
};
var AxiosHttpRetryInterceptorBuilder = (function () {
    /**
     *
     * @param context The window context in which the builder is being instantiated
     */
    function AxiosHttpRetryInterceptorBuilder(metricService, axiosInstance) {
        this.metricService = metricService;
        this.axiosInstance = axiosInstance;
        this.jitter = 0.5;
        this.maxRetryDurationGlobal = 10000;
    }
    AxiosHttpRetryInterceptorBuilder.prototype.setJitter = function (jitterParam) {
        this.jitter = jitterParam; //configurable jitter for testing
    };
    AxiosHttpRetryInterceptorBuilder.prototype.setMaxRetryDuration = function (retryDuration) {
        this.maxRetryDurationGlobal = retryDuration; //configurable jitter for testing
    };
    AxiosHttpRetryInterceptorBuilder.prototype.build = function () {
        var _this = this;
        var metricService = this.metricService;
        var axios = this.axiosInstance;
        var onBeforeRequest = function (config) {
            return config;
        };
        var onRequestError = function (error) {
            // Do something with request error
            return Promise.reject(error);
        };
        // Add a response interceptor
        var onResponseSuccess = function (response) {
            metricService.newCounterMetric('Ajax.HttpRequestSucceded');
            return response;
        };
        var onResponseError = function (error) {
            var response = error.response;
            var requestConfig = error.config;
            if (isRetriableError(response) && !!requestConfig && !requestConfig.wdRetryRequest) {
                return new Promise(function (resolve, reject) {
                    var maxRetryDuration = _this.maxRetryDurationGlobal;
                    //The default value for timeout is zero, only honour the timeout if it's greater than zero
                    if (typeof requestConfig.timeout == 'number' && requestConfig.timeout > 0) {
                        maxRetryDuration = requestConfig.timeout;
                    }
                    //Set a flag on the config that we're initiating retries
                    //This will stop any subsequent failures from re-entring this block of code
                    requestConfig.wdRetryRequest = true;
                    var backoffObj = new Backoff({
                        min: 500,
                        max: maxRetryDuration,
                        jitter: _this.jitter,
                        factor: 2 //exponential backoff
                    });
                    var resolveFunction = function (response) {
                        metricService.newCounterMetric('Ajax.HttpRetrySucceeded');
                        resolve(response);
                    };
                    var retryCall = function () {
                        pendingTimeoutId = null;
                        metricService.newCounterMetric('Ajax.HttpRetry');
                        axios(requestConfig).then(resolveFunction, retryFailedCallback);
                    };
                    var pendingTimeoutId = null;
                    var retryFailedCallback = function (error) {
                        var response = error.response;
                        var duration = backoffObj.duration();
                        if (duration >= maxRetryDuration || !isRetriableError(response)) {
                            //Also check again before every retry failure if we can continue retrying
                            metricService.newCounterMetric('Ajax.HttpRetryFailed');
                            reject(error);
                        }
                        else {
                            pendingTimeoutId = setTimeout(retryCall, duration);
                        }
                    };
                    retryFailedCallback({ response: null });
                });
            }
            ;
            metricService.newCounterMetric('Ajax.HttpRequestFailed');
            return Promise.reject(error);
        };
        return {
            onBeforeRequest: onBeforeRequest,
            onRequestError: onRequestError,
            onResponseSuccess: onResponseSuccess,
            onResponseError: onResponseError
        };
    };
    return AxiosHttpRetryInterceptorBuilder;
}());
exports.default = AxiosHttpRetryInterceptorBuilder;
